import styled from "styled-components"
import { boxShadowColor, green, mediumGreen, mediumLightGrey, white } from "utils/color"

export const FormSection = styled.div`
  background-color: ${white};
  border-radius: 12px;
  box-shadow: 0 4px 4px 0 ${boxShadowColor};
  padding: 24px;
  margin-bottom: 20px;
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`

export const SectionTitle = styled.h3`
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
`

export const SubmitButton = styled.button`
  color: ${white};
  font-family: Poppins;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 14px;
  background-color: ${green};
  border: none;
  transition: all 0.3s ease-in-out;
  margin-top: 8px;

  &:hover {
    background-color: ${mediumGreen};
  }

  &:disabled {
    background-color: ${mediumLightGrey};
    opacity: 0.65;
    cursor: auto;
  }
`
